export type CatalogActionPropertyLink = {
    id: number;
    title: string;
    ssqPropertyIds?: number[];
};

export const findOtherActionsSharingProperty = (
    catalogActions: CatalogActionPropertyLink[] | undefined,
    propertyId: number,
    currentActionId: number,
): CatalogActionPropertyLink[] => {
    if (catalogActions === undefined) {
        return [];
    }

    return catalogActions.filter(
        (action) => action.id !== currentActionId && (action.ssqPropertyIds ?? []).includes(propertyId),
    );
};
